import { render } from "./MfcContactsPeopleInEntitySelector.vue?vue&type=template&id=69c3b2b8"
import script from "./MfcContactsPeopleInEntitySelector.vue?vue&type=script&lang=js"
export * from "./MfcContactsPeopleInEntitySelector.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__